export default "__VITE_ASSET__C1HEDboO__"